var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModalClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.345,
    height: 12.348,
    viewBox: "0 0 12.345 12.348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27790",
    "data-name": "Group 27790",
    transform: "translate(0.707 0.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32006",
    "data-name": "Path 32006",
    d: "M-6384.758-24365.234l10.931,10.934",
    transform: "translate(6384.758 24365.234)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32007",
    "data-name": "Path 32007",
    d: "M-6373.827-24365.234l-10.931,10.934",
    transform: "translate(6384.758 24365.234)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalClose);
export default __webpack_public_path__ + "static/media/modalClose.716ee10708fc5ed41256034e87ee5bed.svg";
export { ForwardRef as ReactComponent };